export interface AbbreviationSettings {
    neverSplitAdded: string[],
    neverSplitSuppressed: string[],
    maySplitAdded: string[],
    maySplitSuppressed: string[],
}

export function emptyAbbreviationSettings(): AbbreviationSettings {
    return {
        neverSplitAdded: [],
        neverSplitSuppressed: [],
        maySplitAdded: [],
        maySplitSuppressed: [],
    };
}

export interface AbbreviationDefaults {
    neverSplit: string[],
    maySplit: string[],
}

export interface AbbreviationSnapshot {
    neverSplit: string[],
    maySplit: string[],
}

export const abbreviationPartLimit = 3;
export const abbreviationEntryLimit = 100;
